import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { PublicUserProfile } from "../../firebase/users";
import Achievements from "../achievements/Achievements";
import { useTranslation } from "react-i18next";
import Avatar from "../shared/Avatar";
import { Grid } from "@material-ui/core";
import { colors } from "../../theme";
import Button from "../shared/Button";

interface Props {
  profile: PublicUserProfile;
  allowedToChangeProfile: Boolean;
}

const useStyles = makeStyles((theme) => ({
  profile: {
    padding: "20px",
    position: "absolute",
    backgroundColor: colors.BACKGROUND_PRIMARY
  },
  displayName: {
    fontSize: "32px",
    fontWeight: 600,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.66",
    letterSpacing: "-0.06px",
    textAlign: "center",
    color: colors.TEXT_PRIMARY,
  },
  country: {
    fontSize: "20px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "-0.05px",
    color: colors.TEXT_PRIMARY,
  },
  avatar: {
    margin: "auto",
    width: "130px",
    height: "130px",
    fontSize: "40px",
    marginTop: "-50px",
    border: "5px solid #FFFFFF",
  },
  button: {
    margin: "20px 0"
  },
  achievements: {
    position: "relative",
    top: "260px",
    padding: "20px",
    backgroundColor: colors.BACKGROUND_SECONDARY
  }
}));

export default function Overview({ profile, allowedToChangeProfile }: Props) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Grid container item direction="row" justify="center">
      <Grid container item direction="column" justify="center" className={classes.profile}>
        <Avatar className={classes.avatar}>{profile.avatar}</Avatar>
        <div style={{ textAlign: "center" }}>
          <div className={classes.displayName}>{profile.displayname}</div>
          <div className={classes.country}>{profile.country}</div>
          {allowedToChangeProfile && (
            <Button linkTo="/profile/edit" className={classes.button}>
            {t("profile.editprofile")}
            </Button>
          )}
        </div>
      </Grid>
      <Grid container item justify="center" className={classes.achievements}>
        <Achievements userId={profile.id} />
      </Grid>
    </Grid>
  );
}
